/** ~1 cm precision — fits Django DecimalField(max_digits=12, decimal_places=8). */
const GPS_DECIMAL_PLACES = 7;

export function formatGpsCoordinate(value: number): string {
  return value.toFixed(GPS_DECIMAL_PLACES);
}
